var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerAdvertisementColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#aa56ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 1.000) scale(0.080000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    transform: "matrix(1 0 0 1 0 0) matrix(8.20321 0 0 7.74648 -13.4326 -4.6409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.81,26.86c-0.39,0 -0.72,-0.15 -1.01,-0.43c-0.29,-0.29 -0.43,-0.63 -0.43,-1.01l0,-10.54c0,-0.38 0.14,-0.72 0.43,-1.01c0.29,-0.28 0.62,-0.43 1.01,-0.43l10.54,0c0.38,0 0.72,0.15 1,0.43c0.29,0.29 0.44,0.63 0.44,1.01l0,10.54c0,0.38 -0.15,0.72 -0.44,1.01c-0.28,0.28 -0.62,0.43 -1,0.43l-10.54,0zm0,-2.68c0.78,-0.52 1.62,-0.9 2.52,-1.15c0.91,-0.26 1.82,-0.39 2.75,-0.39c0.92,0 1.84,0.13 2.74,0.39c0.9,0.25 1.74,0.63 2.53,1.15l0,-9.3l-10.54,0l0,9.3zm5.27,-0.1c-0.85,0 -1.66,0.11 -2.42,0.32c-0.77,0.22 -1.48,0.56 -2.14,1.02l9.11,0c-0.69,-0.46 -1.42,-0.8 -2.21,-1.02c-0.78,-0.21 -1.56,-0.32 -2.34,-0.32zm0,-2.71c-0.74,0 -1.36,-0.26 -1.88,-0.78c-0.52,-0.52 -0.78,-1.14 -0.78,-1.88c0,-0.73 0.26,-1.36 0.78,-1.88c0.52,-0.52 1.14,-0.78 1.88,-0.78c0.73,0 1.36,0.26 1.88,0.78c0.52,0.52 0.78,1.15 0.78,1.88c0,0.74 -0.26,1.36 -0.78,1.88c-0.52,0.52 -1.15,0.78 -1.88,0.78zm-0.02,-1.27c0.4,0 0.73,-0.13 1,-0.39c0.27,-0.27 0.41,-0.59 0.41,-0.99c0,-0.39 -0.14,-0.72 -0.41,-0.99c-0.27,-0.27 -0.6,-0.41 -0.98,-0.41c-0.4,0 -0.73,0.14 -1,0.41c-0.26,0.27 -0.39,0.6 -0.39,0.98c0,0.4 0.13,0.73 0.39,1c0.27,0.26 0.59,0.39 0.98,0.39zm9.84,6.76c-0.21,0 -0.38,-0.07 -0.52,-0.21c-0.13,-0.14 -0.2,-0.31 -0.2,-0.51l0,-11.98c0,-0.2 0.07,-0.37 0.21,-0.51c0.14,-0.14 0.31,-0.21 0.51,-0.21c0.21,0 0.38,0.07 0.51,0.21c0.14,0.14 0.21,0.31 0.21,0.51l0,11.98c0,0.2 -0.07,0.37 -0.21,0.51c-0.14,0.14 -0.31,0.21 -0.51,0.21zm3.83,0c-0.21,0 -0.38,-0.07 -0.51,-0.21c-0.14,-0.14 -0.21,-0.31 -0.21,-0.51l0,-11.98c0,-0.2 0.07,-0.37 0.21,-0.51c0.14,-0.14 0.31,-0.21 0.52,-0.21c0.2,0 0.37,0.07 0.51,0.21c0.13,0.14 0.2,0.31 0.2,0.51l0,11.98c0,0.2 -0.07,0.37 -0.21,0.51c-0.13,0.14 -0.31,0.21 -0.51,0.21z",
    id: "svg_1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerAdvertisementColumn);
export default __webpack_public_path__ + "static/media/marker-advertisement-column.81a6e418ae191f579eaae0a9a0174305.svg";
export { ForwardRef as ReactComponent };